import React from 'react';
interface SectionCardProps {
  id: string;
  number: number;
  title: string;
  description?: string;
  children: React.ReactNode;
}
export function SectionCard({
  id,
  number,
  title,
  description,
  children
}: SectionCardProps) {
  return <section id={id} aria-labelledby={`${id}-heading`} className="scroll-mt-6 overflow-hidden rounded-lg border border-slate-200 bg-white shadow-sm" data-id="element-57" data-mp="1i249szu8uf5o">
      <header className="flex items-center gap-2.5 border-b border-slate-200 bg-slate-50 px-3 py-2" data-id="element-58" data-mp="pf0bfdpnoz2v">
        <span aria-hidden="true" className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-blue-600 text-[11px] font-semibold text-white" data-id="element-59" data-mp="lderx9im9mjp">
          {number}
        </span>
        <div className="min-w-0" data-id="element-60" data-mp="ubiem95c8pd3">
          <h2 id={`${id}-heading`} className="text-sm font-semibold text-slate-900" data-id="element-61" data-mp="6nh9793ghp1w">
            {title}
          </h2>
          {description && <p className="text-xs text-slate-500" data-id="element-62" data-mp="1p5wmqls10fz">{description}</p>}
        </div>
      </header>
      <div className="space-y-3.5 px-3 py-3" data-id="element-63" data-mp="3soz4djkmq59p">{children}</div>
    </section>;
}